import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ReviewSurvey } from 'ha/services/apiV2/types/ReviewSurvey';

export default (makeCall: MakeCall) => (uuid: string) =>
  makeCall<ReviewSurvey>('GET', `/api/v2/review/survey/${uuid}`);
